import { GoogleMapsService } from 'src/app/services/google-maps.service';
import { Component, Input, SimpleChange, SimpleChanges } from '@angular/core';
import { SummaryData } from 'src/app/pages/new-service/interfaces/SummaryData';
import { DistanceTimeInfo, DistanceTimeInfoRequest } from 'src/app/shared/map/map.component';
import { DistanceUnitByZoneId } from 'src/app/shared/pipes/DistanceUnitByZoneId.pipe';
import { firstValueFrom, take } from 'rxjs';
import { LatLng } from 'src/app/pages/new-service/interfaces/LongitudeLatitude';

@Component({
  selector: 'app-distance-time-box',
  templateUrl: './distance-time-box.component.html',
  styleUrls: ['./distance-time-box.component.scss'],
  providers: [DistanceUnitByZoneId]
})
export class DistanceTimeBoxComponent {

  @Input() summaryData!: SummaryData;
  @Input() showData: boolean = false;


  constructor(private googleMapsService: GoogleMapsService, private DistanceUnitByZoneId: DistanceUnitByZoneId) {
  }

  originLat: number | undefined = 0;
  originLng: number | undefined = 0;
  destinationLat: number | undefined = 0;
  destinationLng: number | undefined = 0;
  travelInfo: DistanceTimeInfo | undefined;

  ngOnChanges(changes: SimpleChanges
  ) {
    if (changes['summaryData']) {
      this.setData()
      this.getDistanceTimeInfo();
    }
  }

  setData() {
    if (this.summaryData?.locationInfo) {
      this.originLat = this.summaryData.locationInfo.originAddressLatitude
      this.originLng = this.summaryData.locationInfo.originAddressLongitude
      this.destinationLat = this.summaryData.locationInfo.destinationAddressLatitude
      this.destinationLng = this.summaryData.locationInfo.destinationAddressLongitude
    }

  }


  async getDistanceTimeInfo() {
    if (Number.isFinite(this.originLat) &&
      Number.isFinite(this.originLng) &&
      Number.isFinite(this.destinationLat) &&
      Number.isFinite(this.destinationLng)) {
      let Origin: LatLng = {
        lat: this.originLat,
        lng: this.originLng,
      }

      let Destination: LatLng = {
        lat: this.destinationLat,
        lng: this.destinationLng,
      }

      const info = await firstValueFrom(
        this.googleMapsService.getFormattedTravelInfo(Origin, Destination)
      );

      if (info) {
        this.travelInfo = info;
      }
    }
  }


}
